import { useContext } from "react"
import { CreateAssessmentDefContext } from "../CreateAssessmentDefContext"
import { sectorOptions } from "keys/sectors"
import { useSelector } from "react-redux"
import { categories as categoryKeys } from "keys"


const useFields1 = () => {
    const formValues = useSelector(state => state.form.createAssessmentDef?.values)
    const { categories, affiliations, publishers, assessmentDefs, assessmentDefTypes, readabilityScores } = useContext(CreateAssessmentDefContext)
    const categoryName = formValues?.category?.name || formValues?.category_name

    const fields1 = [
        {
            name: "category",
            placeholder: "*סוג המבדק",
            component: "autoComplete",
            options: categories,
            labelKey: "label",
        },
        {
            name: "name",
            placeholder: "*שם טכני",
            component: "input"
        },
        {
            name: "title",
            placeholder: "כותרת לתצוגה",
            component: "input"
        },
        {
            name: "type",
            placeholder: "*תת סוג",
            component: "autoComplete",
            options: assessmentDefTypes.data?.filter(({ category_name, category_id }) => category_name == formValues?.category?.name || category_id == formValues?.category)
        },
        {
            name: "readability_score",
            placeholder: "גיל יעד",
            component: "autoComplete",
            options: readabilityScores.data
        },
        {
            name: "sector",
            placeholder: "מגזר",
            component: "autoComplete",
            options: sectorOptions
        }
    ]

    const fields1ForChoiseType = [
        fields1[0],
        fields1[1],
        fields1[2],
        fields1[3],
        {
            name: "source_passage",
            component: "autoComplete",
            options: assessmentDefs.data,
            placeholder: "*מבדק האם"
        },
        fields1[4],
        fields1[5]
    ]

    const fields2 = [
        {
            name: "relevancy_from",
            component: "autoComplete",
            options: readabilityScores.data,
            placeholder: "מגיל",
            fullWidth: true
        },
        {
            name: "relevancy_to",
            component: "autoComplete",
            options: readabilityScores.data,
            placeholder: "עד גיל",
            fullWidth: true
        }
    ]

    const fields3 = [
        {
            name: "permission",
            placeholder: "הרשאה",
            component: "autoComplete",
            options: [{ id: "PUBLIC", name: "ציבורי" }, { id: "PRIVATE", name: "פרטי" }]
        },
        {
            name: "author",
            placeholder: "מחבר",
            component: "input"
        },
        {
            name: "publisher",
            placeholder: "הוצאה לאור",
            component: "autoComplete",
            options: publishers.data,
            optionsLimit: 10
        },
        {
            name: "adapted_by",
            placeholder: "עיבוד",
            component: "input"
        },
        {
            name: "year_published",
            placeholder: "שנת הוצאה לאור",
            component: "input"
        },
        {
            name: "affiliation",
            placeholder: "מוסד",
            component: "autoComplete",
            options: affiliations.data,
            optionsLimit: 20
        },
        {
            name: "version",
            placeholder: "גרסא",
            component: "input",
            type: "number"
        }
    ]

    return {
        fields1: categoryName == categoryKeys.MULTIPLE_CHOICE_QUESTIONS ? fields1ForChoiseType : fields1,
        fields2,
        fields3
    }
}

export default useFields1 